
	import { Component, Vue } from 'vue-property-decorator';
	import FormView from './components/FormView.vue';
	import { Observer } from 'mobx-vue';
	import store from '@/store/mainStore';

	@Observer
	@Component({
		components: { FormView }
	})
	export default class PrescriptionView extends Vue {
		async activated() {
			if (!store.biometric.bothScansExist && !store.biometric.leftScanExists && !store.biometric.rightScanExists) {
				await store.biometric.getLatestScans();
			}
		}
	}
